import { render, staticRenderFns } from "./form_menu.vue?vue&type=template&id=c9bd0a2e"
import script from "./form_menu.vue?vue&type=script&lang=js"
export * from "./form_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports